import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import DashboardShell from '../DashboardShell';
import useFetch from '../useFetch';

/**
 * Partner sidebar. The URL carries the reseller id for old links, but data always comes from
 * /api/me (the token), so changing the id in the address bar shows nothing of anyone else's.
 */
const PartnerApp = () => {
  const { currentUser } = useAuth();
  const { id } = useParams();
  const own = currentUser?.reseller_id;
  const overview = useFetch(own ? '/me/overview' : null);
  const todo = (overview.data?.checklist || []).filter((s) => !s.done && s.key !== 'first_sale').length;

  if (own && String(own) !== String(id)) return <Navigate to={`/owner/${own}`} replace />;

  const base = `/owner/${own}`;
  const nav = [
    { to: base, label: 'Overview', icon: 'overview', end: true },
    { to: `${base}/customers`, label: 'My customers', icon: 'customers' },
    { to: `${base}/earnings`, label: 'Commission and payouts', icon: 'commissions' },
    { to: `${base}/share`, label: 'My link and sharing', icon: 'link' },
    { to: `${base}/settings`, label: 'Account settings', icon: 'settings', badge: todo || undefined },
    { to: `${base}/support`, label: 'Support', icon: 'support' },
  ];
  const profile = overview.data?.profile;

  return (
    <DashboardShell
      nav={nav}
      roleLabel="Reseller"
      orgName={profile?.business_name || profile?.name}
      roleNote="Your data only"
      userName={profile?.name || currentUser?.email || 'Partner'}
    />
  );
};

export default PartnerApp;
